<template>
  <div>
    <VTableRemote
      :disabled="!hasPermission('analyses.view')"
      :items="displayedMeasures"
      :isSortable="false"
      :isExportable="true"
      :isFilterEnable="true"
      :headers="tableHeaders"
      :pagination="pagination"
      disablePagination
      hideDefaultFooter
      :title="title"
      :loading="loading"
      :filterItems="getFilterItems"
      :elementsPerPage="queryParams.perpage"
      @filter-type-changed="filterChanged"
      @sendQueryParams="fetchQuery"
    >
      <template #item.measureDot="{ item }">
        <span :class="`dot ${item.measureDot.normsColor}`" /> {{ item.measureDot.value }}
      </template>
      <template #withInfiniteScroll>
        <div v-intersect="endIntersect" />
      </template>
    </VTableRemote>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import normsMixin from '@/mixins/NormsMixin';
import VTableRemote from '@/components/shared/content-views/VTableRemote';
import { historyPerpage } from '@/constants/pagination';

export default {
    components: {
        VTableRemote,
    },
    mixins: [
        normsMixin,
    ],
    data() {
        return {
            loading: false,
            measures: [],
            pagination: {},
            filterItems: ['user', 'controller'],
            queryParams: { page: 1, perpage: historyPerpage, type: null },
        };
    },
    computed: {
        ...mapGetters([
            'hasPermission',
            'component',
            'analysisType',
            'userLang',
        ]),
        title() {
            return `${this.component.name}: ${this.analysisType.name[this.userLang]}`;
        },
        tableHeaders() {
            return [
                'measuredAt',
                'measureDot',
                'veryLow',
                'low',
                'minimum',
                'maximum',
                'high',
                'veryHigh',
                'measuredBy',
                'note',
            ].map(value => ({
                text: this.$t(`measures.labels.${value}`),
                value,
            }));
        },
        displayedMeasures() {
            return this.measures.map(measure => {
                const { low, veryLow, minimum, maximum, high, veryHigh } = measure.analysis.norm;
                return {
                    measuredAt: this.$options.filters.formatDate(measure.measuredAt, 'L LT'),
                    measureDot: {
                        value: measure.value,
                        normsColor: this.getColor(measure.value, measure.analysis.norm),
                    },
                    veryLow,
                    low,
                    minimum,
                    maximum,
                    high,
                    veryHigh,
                    measuredBy: measure.measuredBy ? measure.measuredBy.email : '',
                    note: measure.note,
                };
            });
        },
        getFilterItems() {
            return this.filterItems.map((item, key) => ({
                key,
                name: this.$t(`forms.labels.${item}MeasuredBy`),
            }));
        },
        historyPerpage() {
            return historyPerpage;
        },
    },
    created() {
        this.getMeasureHistoryAll();
    },
    methods: {
        async loadData() {
            if (this.loading) return;
            this.loading = true;
            const { data: { measures, pagination } } = await this.$rq.getMeasureHistoryAll({
                analysisType: this.$route.params.analysisTypeId,
                component: this.$route.params.componentId,
                activity: this.$route.params.measuresAndSamplesCollectActivity,
                ...this.queryParams,
            });
            this.measures = [...this.measures, ...measures];
            this.pagination = pagination;
            this.loading = false;
        },
        getMeasureHistoryAll() {
            this.loadData();
        },
        filterChanged(index) {
            this.queryParams = {
                ...this.queryParams,
                type: this.filterItems[index],
                page: 1,
            };
            this.loadData();
        },
        fetchQuery({ perpage, page }) {
            this.queryParams = {
                ...this.queryParams,
                page,
                perpage,
            };
            this.loadData();
        },
        async endIntersect(_, __, isIntersecting) {
            const condition = this.pagination.hasNextPage;
            if (isIntersecting && condition && !this.loading) {
                this.queryParams.page = this.pagination.currentPage + 1;
                await this.loadData();
                const ref = this.$refs?.tableRemoteRef?.$refs?.tableRemote;
                if (ref?.onScroll) {
                // workaround to refresh list after adding new items.
                    ref.onScroll();
                }
            }
        },
    },
};
</script>
